import { CERTIFICATE_SUCCESS, CERTIFICATE_FAILURE } from '../actions/actions';
const initialState = {};

export default function certificate(state=initialState, action) {
  // console.log(action.type, action);
  switch (action.type) {
    case CERTIFICATE_SUCCESS:
    action.payload.errMsg = null;
    console.log("return action.payload", action.payload);
      return Object.assign({},
        state,
        action.payload
      );
    case CERTIFICATE_FAILURE:
      console.log(action.type, action.payload);
      return Object.assign({},
        state,
        action.payload
      );
    default:
      return state;
  }
}